import { Common } from '@stockbit/ui';

import styled from 'styled-components';

const { Modal } = Common;

export const ModalDocument = styled(Modal)`
  padding-bottom: 0px !important;
  margin: 0;
  max-width: unset;
  .ant-modal-content {
    position: unset;
    background-color: transparent;
    box-shadow: none;
  }
  .ant-modal-body {
    display: flex;
    justify-content: center;
    align-items: center;
    > div {
        width: 100%;
    }
  }  
`;
